module.exports = __webpack_public_path__ + "media/images/front/top/minnebro-282f05648dc2003275287d4924af6648.jpg";